import { SOFTLINE_API_WEBDOC_EDIT_FILE_NAME } from '../bauprofi.api';
import { ApiDataAccess, ApiResourceLocation, ResourceService } from '@softline/core';
import { firstValueFrom } from 'rxjs';
import { WebDocumentFile } from '../types/web-document';

export async function renameFile(
  service: ApiDataAccess,
  params: { fileUrl: string; newTitle: string }
): Promise<WebDocumentFile> {
  const location = {
    path: SOFTLINE_API_WEBDOC_EDIT_FILE_NAME,
  } as ApiResourceLocation;

  return await service.patch<object, WebDocumentFile>(location, params);
}
